/**
 * @param {object} props
 * @param {Array<{ _id: string, name: string, relationshipLabel?: string, preferences?: string, avatarGridUrl?: string }>} props.profiles
 * @param {(index: number) => void} props.onSelectIndex
 */
export default function GameCharacterGrid({ profiles, onSelectIndex }) {
  if (!profiles?.length) return null;
  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 sm:gap-5">
      {profiles.map((p, i) => (
        <button
          key={String(p._id)}
          type="button"
          onClick={() => onSelectIndex(i)}
          className="group flex flex-col overflow-hidden rounded-2xl border border-white/10 bg-game-surface/50 text-left shadow-md outline-none ring-game-accent/40 transition hover:border-game-accent/35 hover:shadow-lg focus-visible:ring-2"
        >
          <div className="aspect-[3/4] w-full overflow-hidden bg-game-tint">
            {p.avatarGridUrl ? (
              <img
                src={p.avatarGridUrl}
                alt=""
                className="h-full w-full object-cover transition duration-200 group-hover:scale-[1.02]"
              />
            ) : (
              <div className="flex h-full w-full flex-col items-center justify-center gap-1">
                <span className="text-4xl font-semibold text-game-muted/40" aria-hidden>
                  {p.name?.[0]?.toUpperCase() || '?'}
                </span>
                <span className="text-[10px] uppercase tracking-wide text-game-muted/80">No image</span>
              </div>
            )}
          </div>
          <div className="border-t border-white/10 px-3 py-2.5">
            <p className="truncate text-sm font-semibold text-game-text">{p.name}</p>
            <p className="mt-1 truncate text-[11px] leading-snug text-game-body">
              <span className="font-semibold text-game-muted">Role:</span>{' '}
              {p.preferences && p.preferences !== '—' ? p.preferences : '—'}
            </p>
            <p className="truncate text-[11px] leading-snug text-game-body">
              <span className="font-semibold text-game-muted">Relationship:</span>{' '}
              {p.relationshipLabel || '—'}
            </p>
          </div>
        </button>
      ))}
    </div>
  );
}
